/* export const apiUrl= process.env.REACT_APP_API_URL; */
export const apiUrl = "https://draparejasapi.rocazit.com";
//export const apiUrl = "http://localhost:8000";
export const drName = "Dra. Carla Parejas";
export const specificConfigurationDataUrl =
  apiUrl + "/api/v1/configuracion/getdoctor";

//aca se asigna el backend que voy a utilizar.
